import Base from './base'

export default class CellNotesApi extends Base {
  listIndicators(params = {}) {
    return this.apiClient.get('cell-notes/indicators', params)
  }

  // Note→cell attribution links (suggested + confirmed) for a specific cell.
  listLinksForCell(params = {}) {
    return this.apiClient.get('cell-notes/links', params)
  }

  confirmLink(id: string) {
    return this.apiClient.put(`cell-notes/links/${id}/confirm`, {})
  }

  dismissLink(id: string) {
    return this.apiClient.put(`cell-notes/links/${id}/dismiss`, {})
  }
}
